import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Brand colors are sampled from the Turn10 Racing logo
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: '#1E6EF0',   // racing blue
        secondary: '#14171F', // carbon
        accent: '#FF6A1A',    // sunset orange
        background: '#0A0C10',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
